import { graphql } from "relay-runtime"

const chFavoriteAgentsByPatientQuery = graphql`
  query chFavoriteAgentsByPatientQuery($patientId: ID!) {
    patientById: ch_patientById(id: $patientId) {
      favoriteAgentUserNames
    }
  }
`
export { chFavoriteAgentsByPatientQuery as ch_FavoriteAgentsByPatientQuery }
